import React from "react";
import { withLocalizer } from "utilities/withLocalizer";
import moment from "moment";
import { CONFIGURATION } from "utilities/configuration";
import { CONSTANTS } from "utilities/constants";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";

import CustomizedDatePicker from "components/date-picker/index";

import "react-datepicker/dist/react-datepicker.css";

import "../../customize.scss";

const ItineraryInfo = (props) =>  {
    const { option, itinerary, product, includeExpiryDateSelector, languageCode } = props;
    const productType = option?.productType?.code.trim().toLowerCase();

    const minDate = new Date();
    minDate.setHours(0, 0, 0, 0);

    const maxDate = moment(itinerary.originalValidDate).toDate();

    const handleDateChange = (date, itinerary) => {
        if(props.handleDateChange) {
            props.handleDateChange(date, itinerary);
        }
    };

    return (
        <>
            <div>
                <div>
                    {productType === CONSTANTS.FLIGHT
                        ? 
                        <>
                            <strong>{itinerary?.itineraryDetail?.flight?.sourceToDestination.departure?.name}({itinerary?.itineraryDetail?.flight?.sourceToDestination.departure?.code})</strong>{<span> - </span>}
                            <strong>{itinerary?.itineraryDetail?.flight?.sourceToDestination.arrival?.name}({itinerary?.itineraryDetail?.flight?.sourceToDestination.arrival?.code})</strong>{<span> | </span>}
                            <strong>{moment(itinerary?.itineraryDetail?.flight?.sourceToDestination?.departure?.date).format(CONFIGURATION.DATE_FORMAT)} {props.localize("qma-for")} {option?.duration} {props.localize("qma-days")}</strong>{<span> | </span>}
                            {itinerary?.itineraryDetail?.flight?.sourceToDestination?.flightNo && <strong>{itinerary?.itineraryDetail?.flight?.sourceToDestination?.flightNo}{" " + props.localize("qma-at") + " "}{itinerary.itineraryDetail?.flight?.sourceToDestination?.departure?.time}</strong>}
                        </>
                        : null
                    }
                    {
                        productType === CONSTANTS.PACKAGE ? <><strong>{product.name}</strong> <span>|</span> <strong>{itinerary?.itineraryDetail?.roomType?.name}</strong></> : null
                    }
                    {
                        productType === CONSTANTS.HOTEL ? <><strong>{product.name}</strong> <span>|</span> <strong>{itinerary?.itineraryDetail?.roomType?.name} </strong> <span>|</span> <strong>{moment(option?.departureDate).format(CONFIGURATION.DATE_FORMAT)} {props.localize("qma-for")} {option?.duration} {props.localize("qma-days")}</strong></> : null
                    }
                </div>
                {productType === CONSTANTS.PACKAGE ? 
                    <div className="itinerary-blurb">
                        {itinerary?.itineraryDetail?.flight?.sourceToDestination.departure?.name}({itinerary?.itineraryDetail?.flight?.sourceToDestination.departure?.code}){<span> - </span>}
                        {itinerary?.itineraryDetail?.flight?.sourceToDestination.arrival?.name}({itinerary?.itineraryDetail?.flight?.sourceToDestination.arrival?.code}){<span> | </span>}
                        {moment(itinerary?.itineraryDetail?.flight?.sourceToDestination?.departure?.date).format(CONFIGURATION.DATE_FORMAT)} {props.localize("qma-for")} {option?.duration} {props.localize("qma-days")}
                        {itinerary?.itineraryDetail?.flight?.sourceToDestination?.flightNo ? 
                            <>
                                <span> | </span> 
                                {itinerary?.itineraryDetail?.flight?.sourceToDestination?.flightNo}{" " + props.localize("qma-at") + " "}{itinerary.itineraryDetail?.flight?.sourceToDestination?.departure?.time}
                            </>
                            : null
                        }
                    </div> : null
                }
            </div>
            {includeExpiryDateSelector &&
                <div className="itinerary-expiry-date-selector">
                    <div className="date-selector-label">
                        {itinerary.included && itinerary.showValidDateWarningIcon && <div>
                            <WarningRoundedIcon />
                        </div>}
                        <div>
                            {props.localize("qma-expires-on")}
                        </div>
                    </div>
                    <div className="date-selector-wrapper">
                        <CustomizedDatePicker
                            minDate={minDate}
                            maxDate={maxDate}
                            value={itinerary.validDate && moment(itinerary.validDate).toDate()}
                            isDisabled={!itinerary.included}
                            languageCode={languageCode}
                            enableClearButton={false}
                            showWarning={itinerary.included && itinerary.showValidDateWarningIcon}
                            handleDateChange={(date) => handleDateChange(date, itinerary)}
                        />
                    </div>
                </div>
            }
        </>
    );
};

export default withLocalizer(ItineraryInfo);